module.exports = __webpack_public_path__ + "img/ratesIcon.adb17399.svg";